import React from 'react';
import PropTypes from 'prop-types';

const FileSearch = ({ width, height, ...props }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 38 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M29.7854 39.2441L36.5413 46.0001"
        stroke="#9000FF"
        strokeWidth="2.4"
        strokeLinecap="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23.3154 5.81694H8.19883C7.55725 5.81694 6.97611 6.07729 6.55536 6.49726C6.13462 6.918 5.87427 7.49914 5.87427 8.14149V42.235C5.87427 42.8766 6.13462 43.4577 6.55536 43.8785C6.97611 44.2992 7.55725 44.5596 8.19883 44.5596H32.9941C33.6357 44.5596 34.2168 44.2992 34.6376 43.8785C35.0583 43.4577 35.3187 42.8766 35.3187 42.235V17.7907C35.3187 17.1732 35.073 16.5804 34.6352 16.1449L24.9566 6.49416C24.5211 6.06024 23.9307 5.81616 23.3154 5.81616V5.81694Z"
        stroke="#9000FF"
        strokeWidth="2.4"
      />
      <path
        d="M31.2491 12.7906V5.09941C31.2491 3.38699 29.8621 2 28.1497 2H5.09941C3.38699 2 2 3.38699 2 5.09941V37.5998C2 39.3122 3.38699 40.6992 5.09941 40.6992H5.73479"
        stroke="#9000FF"
        strokeWidth="2.4"
      />
      <path
        d="M23.6959 41.4601C28.4032 41.4601 32.2192 37.644 32.2192 32.9367C32.2192 28.2294 28.4032 24.4133 23.6959 24.4133C18.9885 24.4133 15.1725 28.2294 15.1725 32.9367C15.1725 37.644 18.9885 41.4601 23.6959 41.4601Z"
        stroke="#9000FF"
        strokeWidth="2.4"
      />
      <path d="M21.8217 33.53H25.8217" stroke="#9000FF" strokeWidth="2.4" strokeLinecap="round" />
    </svg>
  );
};

FileSearch.defaultProps = {
  width: 38,
  height: 48
};

FileSearch.propTypes = {
  width: PropTypes.oneOf([PropTypes.string, PropTypes.number]),
  height: PropTypes.oneOf([PropTypes.string, PropTypes.number])
};

export default FileSearch;
